@import '../../../../themes/site/default/assets/common_helpers_non_liquid.scss';
@import '../../../../themes/site/default/assets/responsive_helpers.scss';

.section--upcoming-events-calendar {
  .calender__container {
    position: relative;

    .calender--scroll_btns {
      width: 40px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      button {
        height: 40px;
        background: #ffffff;
        /* Gray/Gray-400 */
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        cursor: pointer;
      }

      button:disabled {
        opacity: 0.36;
        cursor: default;
      }

      button:hover {
        background: #f7fafc;
      }
    }

    .upcoming-events-calendar {
      --fc-border-color: var(--color-border);
      max-width: calc(100% - 65px);

      &--uninitialized {
        position: relative;
        min-height: 50px;
        &:before {
          content: '';
          position: absolute;
          left: calc(50% - 18px);
          top: calc(50% - 18px);
          border: 4px solid var(--color-border);
          border-top: 4px solid var(--color-primary);
          border-radius: 50%;
          width: 36px;
          height: 36px;
          animation: spinner-spin 0.8s linear infinite;
        }
        @keyframes spinner-spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }

      @media (max-width: $large) {
        overflow-x: auto;

        > .fc-view-harness {
          min-width: 740px;
        }
      }

      .fc-multiMonth-view thead .fc-scroller {
        overflow: hidden !important;

        .fc-col-header-cell.fc-day {
          font-weight: bold;
          padding: 4px 0px;
          a {
            font-size: 12px;
            color: var(--color-heading);
          }
        }
      }

      .fc-daygrid-day-frame {
        min-height: 128px;
        padding: 4px;
      }

      .fc-daygrid-day-number {
        flex: 1;
        display: inline-flex;
        justify-content: flex-end;
        .month-text {
          margin-right: auto;
        }
      }

      .fc-daygrid-body table {
        background: var(--color-body);

        tr:has(.start-of-month-cell) td {
          border-bottom: 2px solid var(--color-border-grey);
        }

        // This class doesn't necessary mean the month-start.
        // Fullcalendar applies this to the first date of the month that's visible.
        // Example if Feb 5 is the first february date visible, it'll have this class.
        // For true month-start, use the start-of-month-cell class.
        .fc-daygrid-month-start {
          font-weight: normal;
          font-size: 1em;
        }

        td {
          &.start-of-month-cell {
            border-left: 2px solid var(--color-border-grey);
            border-top: 2px solid var(--color-border-grey);
            border-bottom: none !important;
            color: var(--color-button-text);

            a.fc-daygrid-day-number {
              font-weight: bold;
              font-size: 90%;
              display: inline-flex;
              flex: none;
              flex-shrink: 0;
              color: var(--color-button-text);
              background-color: #a8a8a8;
              padding: 2px 5px;
              border-radius: 1rem;
            }
          }

          &.end-of-month-cell {
            border-bottom: 2px solid var(--color-border-grey);
          }

          &.start-of-month-cell ~ td {
            border-top: 2px solid var(--color-border-grey);
            border-bottom: none !important;
          }

          & > td {
            border-bottom: 2px solid var(--color-border-grey);
          }

          a {
            color: var(--color-text);
          }
        }
      }

      .fc-daygrid-event {
        font-size: 11px;
        .fc-event-time {
          color: var(--color-secondary);
        }
        .fc-event-title {
          color: var(--color-primary);
          text-overflow: ellipsis;
        }
      }

      &--transparent {
        .fc-daygrid-body table {
          background-color: transparent;
        }

        @supports (
          (-webkit-backdrop-filter: blur(6px)) or (backdrop-filter: blur(6px))
        ) {
          .fc-scrollgrid-section-header > * {
            background: transparent;
            -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
          }
        }
      }
    }
  }
}
